<template>
    <div>
        <div
            v-if="isTestRun"
            class="kgr-alert kgr-alert--info kgr-row "
        >
            <div class="kgr-postfix kgr-postfix--center kgr-postfix--smallGutters">
                <div class="kgr-postfix__fixed">
                    <kgr-icon
                        icon-class="info-circle"
                        :small="true"
                    />
                </div>
                <div class="kgr-postfix__fluid kgr-test">
                    {{ tTestRunHint }}
                </div>
            </div>
        </div>
        <kgr-list-action-errors
            v-if="showErrors"
            :errors="errors"
            :entity-ids="entityIds"
            :is-test-run="isTestRun"
        />
        <div
            v-else
            class="kgr-alert kgr-alert--success kgr-row"
        >
            {{ tNoErrorsHint }}
        </div>
        <hr class="kgr-separator" />
        <div class="kgr-row">
            <button
                class="kgr-button kgr-button--secondary"
                @click="$emit('onClose')"
            >
                {{ tButtonCancel }}
            </button>
            <button
                class="kgr-button kgr-button--accent"
                @click="$emit('onBackToAction')"
            >
                {{ tButtonBackToAction }}
            </button>
            <button
                v-if="isTestRun"
                class="kgr-button kgr-button--accent"
                @click="$emit('onExecute')"
            >
                {{ tButtonExecute }}
            </button>
        </div>
    </div>
</template>

<script>
import Icon from '../../common/icon/Icon.vue';
import ListActionErrors from './errors/ListActionErrors.vue'

export default {
    components: {
        'kgr-icon': Icon,
        'kgr-list-action-errors': ListActionErrors,
    },
    props: {
        errors: {
            type: Array,
            required: true,
        },
        entityIds: {
            type: Array,
            required: true,
        },
        isTestRun: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        showErrors() {
            return this.errors.length > 0;
        },
        tTestRunHint() {
            return this.$t('Lists.actions.errors.testRun.hint');
        },
        tNoErrorsHint() {
            return this.$t('Es sind keine Fehler aufgetreten');
        },
        tButtonBackToAction() {
            return this.$t('Zurück zur Übersicht');
        },
        tButtonCancel() {
            return this.$t('cancel');
        },
        tButtonExecute() {
            return this.showErrors ? this.$t('Für alle anderen Ausführen') : this.$t('Ausführen');
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
